import { JOB_URL } from "@workspace/common/src/config";
import { BASE_QUESTION, BASE_ASSESSMENT, BASE_RESULTS } from "./url_helper";
import { Axios } from "@workspace/common";

const { APIClient } = Axios;

const api = new APIClient();

// Dinie - Question Bank

// Get All Questions
export const fetchAllQuestions = () =>
  api.get(`${JOB_URL}${BASE_QUESTION}/all`);

// Get Question by ID
export const fetchQuestionById = (id) =>
  api.get(`${JOB_URL}${BASE_QUESTION}/${id}`);

// Create Question
export const createQuestion = (data) =>
  api.create(`${JOB_URL}${BASE_QUESTION}/create`, data);

// Update Question
export const updateQuestion = (id, data) =>
  api.put(`${JOB_URL}${BASE_QUESTION}/update/${id}`, data);

// Delete Question
export const deleteQuestion = (id) =>
  api.delete(`${JOB_URL}${BASE_QUESTION}/delete/${id}`);

// Upload Questions
export const uploadFileQuestions = (data, config) =>
  api.create(`${JOB_URL}${BASE_QUESTION}/upload`, data, config);

// Count Questions
export const countAllQuestions = () =>
  api.get(`${JOB_URL}${BASE_QUESTION}/count`);

// Count Assessments
export const countAllAssessments = () =>
  api.get(`${JOB_URL}${BASE_ASSESSMENT}/count`);

// Ryan - Assessment

// Get All Assessments
export const fetchAllAssessments = () =>
  api.get(`${JOB_URL}${BASE_ASSESSMENT}/all`);

// Get Assessment by ID
export const fetchAssessmentById = (id) =>
  api.get(`${JOB_URL}${BASE_ASSESSMENT}/${id}`);

// Delete Assessment by ID
export const deleteAssessmentById = (id) =>
  api.delete(`${JOB_URL}${BASE_ASSESSMENT}/delete/${id}`);

// Create Assessment
export const createAssessment = (randomizeBoolean, data) =>
  api.create(
    `${JOB_URL}${BASE_ASSESSMENT}/create?randomize=${randomizeBoolean}`,
    data
  );

// Results

// Create Result
export const createResult = (data) =>
  api.create(`${JOB_URL}${BASE_RESULTS}/create`, data);

// Update Result
export const updateResult = (id, data) =>
  api.put(`${JOB_URL}${BASE_RESULTS}/update/${id}`, data);

// Mark Result
export const markResult = (id) =>
  api.put(`${JOB_URL}${BASE_RESULTS}/mark/${id}`);

//Get Result By Test ID
export const getResultByTestId = (id) =>
  api.get(`${JOB_URL}${BASE_RESULTS}/test/${id}`);

//Get Results Count
export const getResultsCount = () => api.get(`${JOB_URL}${BASE_RESULTS}/count`);

// Fetch Results by Candidate Id
export const getResultsByCandidateId = (id) =>
  api.get(`${JOB_URL}${BASE_RESULTS}/candidate/${id}`);
